import type { ModuleFeature, Permission } from "@cafe/shared";
import { Button, EmptyState, Skeleton } from "@cafe/ui";
import { Construction, ShieldOff } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useCan, useEntitlements, useFeature, usePermissions } from "@/shared/hooks/session";
import { FeaturePromo } from "./feature-promo";

/** Экран раздела: без права — «Недостаточно прав», без функции тарифа — upsell (ТЗ 12 §2 Feature gating). */
export function PageGuard({ permission, anyPermission, feature, children }: { permission?: Permission; anyPermission?: Permission[]; feature?: ModuleFeature; children: ReactNode }) {
  const perms = usePermissions();
  const ent = useEntitlements();
  const can = useCan();
  const hasFeature = useFeature();
  const { t } = useTranslation();
  if (perms.isPending || ent.isPending) return <Skeleton className="h-64" />;
  if ((permission && !can(permission)) || (anyPermission && !anyPermission.some(can))) {
    return <EmptyState icon={<ShieldOff />} title={t("guards.noAccess")} description={t("guards.noAccessHint")} />;
  }
  if (feature && !hasFeature(feature)) return <FeatureLocked feature={feature} />;
  return <>{children}</>;
}

/** Раздел не входит в тариф — витрина дополнения с кнопкой «Подключить». */
export function FeatureLocked({ feature }: { feature: ModuleFeature }) {
  return <FeaturePromo feature={feature} />;
}

export function ComingSoon({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={<Construction />}
      title={t("guards.soonTitle", { title })}
      description={t("guards.soonHint")}
      action={<Button variant="outline" asChild><Link to="/">{t("shell.home")}</Link></Button>}
    />
  );
}
